<template>
    <div class="container">
        <p>403</p>
        <h1>Acceso Denegado</h1>
        <h5>Serás redirigido a la página inicial en <span id="countdown">{{ countdown }}</span> segundos.</h5>
        <img class="alarm" :src="require('@/assets/img/No-Access.svg')" alt="Acceso Denegado Compliance">
    </div>
</template>
<script>
export default {
    name: 'NoAccessViews',

    data() {
        return {
            countdown: 5 
        };
    },

    mounted() {
        this.startCountdown();
    },

    methods: {
        startCountdown() {
            const interval = setInterval(() => {
                if (this.countdown <= 0) {
                    clearInterval(interval);
                    this.$router.push({ name: "Login" });
                } else {
                    this.countdown--;
                }
            }, 1000);
        }
    }
}
</script>
<style scoped>
body {
    background-color: #E1E1E1;
    cursor: not-allowed;
    pointer-events: none;
}

.container {
    display: flexbox;
    height: 100vh;
    justify-content: center;
    align-items: center;
    text-align: center;
    -webkit-user-select: none;  
    -moz-user-select: none;     
    -ms-user-select: none;      
    user-select: none;     
    cursor: not-allowed;     
}

.container > p {
    font-size: 20vh;
    margin: 0;
}

.container > h1 {
    margin: 0;
    font-size: 4vh;
}

.container > img {
    height: 300px;
    width: 300px;
    margin-top: 20px;
}
</style>